import React from 'react';

const Object_Reference = () => {
  return (
    <div >
      <h1>Object_Reference</h1>
      <p>Placeholder component for: "Object Reference"</p>
    </div>
  );
};

export default Object_Reference;
